export const AUSHA_PLAYER_LINK = "https://player.ausha.co/index.html?podcastId=:podcastId&playlist=:playlist&color=%2372238e&v=3&playerId=:playerId"
export const AUSHA_PLAYER_ID = "ausha-ElHF";

export const DEMAND_SOCIAL_HOUSING_LINK = "https://www.demande-logement-social.gouv.fr"
export const LLI_INFO_PAGE_LINK = "/editorial/le-logement-intermediaire/logement-a-loyer-intermediaire"

export const YOUTUBE_CHANNEL_LINK = "https://www.youtube.com/channel/UCzjQVpmwNbv9Zye7JZAT-kQ/featured"
export const LINKEDIN_PAGE_LINK = "https://www.linkedin.com/company/les-residences-yvelines-essonne/"

export const APILOGI_LINK = "https://apilogis.fr/"